import React from "react";
import Moment from "react-moment";
import {FaBirthdayCake, FaClock} from "react-icons/fa";

export const UserProfileInformation = ({profileInfo}) => {

    return (
        <>
            <div className="profile-avatar">
                {profileInfo?.genderIdentityFlag && (
                    <div className={`flag ${profileInfo?.genderIdentityFlag} rotating`}></div>
                )}
                <img alt="" src={profileInfo?.urlProfileImage} />
            </div>
            <div className="profile-info">
                {
                    (profileInfo?.nickname) ?
                        <>
                            {(profileInfo?.pronoun) ? <span>{profileInfo.pronoun}</span> : null}
                            <h4>{profileInfo?.nickname}</h4>
                            <h5>
                                {profileInfo?.firstName}{" "}{profileInfo.lastName}
                            </h5>
                        </>
                        :
                        <>
                            {(profileInfo?.pronoun) ? <span>{profileInfo.pronoun}</span> : null}
                            <h4>
                                {profileInfo?.firstName}{" "}{profileInfo.lastName}
                            </h4>
                        </>
                }

                <ul className="profile-info__extra">
                    <li>
                        <span role={"img"}><FaBirthdayCake /></span>
                        <div className={"details"}>
                            <small>Nació</small>
                            <p><Moment locale="es" format="DD [de] MMMM  YYYY">{profileInfo?.birthday}</Moment></p>
                        </div>
                    </li>
                    <li>
                        <span role={"img"}><FaClock /></span>
                        <div className={"details"}>
                            <small>Se unió</small>
                            <p>{profileInfo?.seniority}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </>
    );
}